import { useCallback, useEffect } from "react";
import SessionsApi from "@common/api/SessionClient";
import ComplianceSessionClient from "@common/api/ComplianceSessionClient";
import LoadingAction from "@common/redux/actions/LoadingAction";
import SessionalDetailsAction from "../../redux/actions/SessionalDetailsAction";
import SessionalPositionsAction from "../../redux/actions/SessionalPositionsAction";
import { handleError } from "@common/components/helpers/error";
import { useSelector } from "react-redux";
import useLogin from "./useLogin.js";

export const useSessions = (isComplianceMobile, open) => {
  const { showOnline, showOffline, showNonOp } = useSelector((state) =>
    SessionalPositionsAction.getStatePath(state),
  );

  const [{ isDesktop, site }] = useLogin();
  const compliance = useSelector((state) => state.complianceSummaryTab);
  useLoadDetails({ isComplianceMobile, open });

  const handleRefresh = useCallback(() => {
    if (!open) {
      return;
    }

    SessionalDetailsAction.reset().then(() => {
      LoadingAction.set(true).then(() => {
        const fnSearch = isDesktop
          ? async () => {
              return await ComplianceSessionClient.GetSessionsPositions(
                compliance.eventsGridActiveRow.site.id,
              );
            }
          : async () =>
              site
                ? await SessionsApi.CompliancePositions(
                    showOnline,
                    showOffline,
                    showNonOp,
                    site.id,
                  )
                : await SessionsApi.Positions(
                    showOnline,
                    showOffline,
                    showNonOp,
                  );

        fnSearch()
          .then((positions) =>
            SessionalPositionsAction.dispatch({
              ...positions,
              activeRow: null,
            })
              .then(() => LoadingAction.set(false))
              .catch(handleError),
          )
          .catch(handleError);
      });
    });
  }, [showOnline, showOffline, showNonOp, open, compliance]);

  useEffect(() => {
    handleRefresh();
  }, [handleRefresh]);

  return handleRefresh;
};

const useLoadDetails = ({ isComplianceMobile, open }) => {
  const [{ isDesktop }] = useLogin();

  const positions = useSelector((state) =>
    SessionalPositionsAction.getStatePath(state),
  );
  const details = useSelector((state) =>
    SessionalDetailsAction.getStatePath(state),
  );

  useEffect(() => {
    if (!positions.activeRow || !positions.activeRow.installationId || !open) {
      return;
    }
    LoadingAction.set(true).then(() => {
      const fnSearch = isDesktop
        ? ComplianceSessionClient.GetSessions
        : isComplianceMobile
          ? SessionsApi.SessionsCompliance
          : SessionsApi.Sessions;

      fnSearch(
        positions.activeRow.installationId,
        details.periodType,
        details.pageNumber,
      ).then(
        (grid) => {
          SessionalDetailsAction.dispatch(grid).then(() =>
            LoadingAction.set(false),
          );
        },
        (error) => handleError(error),
      );
    });
  }, [positions, details.periodType, details.pageNumber, open]);
};
